import { ReactNode } from 'react';
import { clsx } from 'clsx';

import { Icon, TIconSize, Tooltip } from '@treezor/design-system';

import { TTipPlacement } from './Tips.types';

export interface IInfoTooltipProps {
  className?: string;
  iconClassName?: string;
  tooltipPlacement?: TTipPlacement;
  tooltipInfo?: ReactNode;
  infoClassName?: string;
  size?: TIconSize;
}

export function InfoTooltip({
  className,
  iconClassName,
  tooltipInfo,
  tooltipPlacement,
  infoClassName,
  size = 's',
}: IInfoTooltipProps) {
  return (
    <Tooltip
      placement={tooltipPlacement}
      messageContent={tooltipInfo}
      contentClassName={clsx(infoClassName, 'leading-normal')}
      className={clsx('leading-none', className)}
    >
      <Icon
        name="info"
        isFill={false}
        size={size}
        className={clsx('cursor-default text-icon-secondary hover:text-icon-interactive', iconClassName)}
      />
    </Tooltip>
  );
}
